/*
 * Add-on-Upsell im Warenkorb-Drawer.
 * Delegiert am document, weil der Drawer bei jedem Cart-Update komplett
 * neu gerendert wird und direkt gebundene Handler dabei verloren gingen.
 */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-mv-addon-add]');
  if (!button) return;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const item = button.closest('.cart-addons__item');
  const select = item.querySelector('[data-mv-addon-variant]');
  const errorField = document.querySelector('[data-mv-addon-error]');

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  errorField.hidden = true;

  try {
    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(select ? select.value : button.dataset.variantId), quantity: 1 }],
        sections: drawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    });

    const state = await response.json();
    if (state.status) throw new Error(state.description || state.message);

    drawer.renderContents(state);
  } catch (error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    errorField.textContent = error.message || 'Konnte nicht hinzugefügt werden.';
    errorField.hidden = false;
  }
});
